export default __webpack_public_path__ + "static/media/kitchen5-beforeD-480w.398aa07a.png";